import cx from 'classnames';
import TransitChargeState from '~/constants/vdp/TransitChargeState';
import { type TransitChargeInfo } from '~/hooks/vdp/selectors/useTransitChargeInfo';
import formatAndDropDecimal from '~/utilities/formatAndDropDecimal';

type OwnProps = {
  transitCharge: TransitChargeInfo;
};

export default function TransitInfo({ transitCharge }: OwnProps) {
  return (
    <span
      data-testid="transit-info"
      className={cx('w-fit', {
        'text-text-success t-label-sm':
          transitCharge.state === TransitChargeState.NoCharge,
        hidden: transitCharge.state === TransitChargeState.Unknown
      })}
    >
      {transitCharge.state === TransitChargeState.HasCharge
        ? `$${formatAndDropDecimal(transitCharge.charge)}`
        : 'Free'}{' '}
      shipping
    </span>
  );
}
